// 通用加权随机：基于 probability 字段，过滤 <=0 的项
export function weightedPick(list) {
  const arr = (list || []).filter((x) => x && x.probability > 0)
  if (!arr.length) return null
  const total = arr.reduce((s, x) => s + x.probability, 0)
  let r = Math.random() * total
  for (const x of arr) {
    r -= x.probability
    if (r <= 0) return x
  }
  return arr[arr.length - 1]
}

// group.partners 中按权重选一个 partner，可传函数过滤
function pickPartner(group, predicate) {
  if (!group || !group.partners) return null
  const list = Object.entries(group.partners)
    .map(([key, p]) => ({ ...p, _key: key }))
    .filter((p) => (predicate ? predicate(p) : true))
  return weightedPick(list)
}

/**
 * 创建一次广告会话（页面会话级）：
 * - 进入页面时调用一次，按权重锁定一个主 partner
 * - 通过 pickAd(slotName) 获取广告，主 partner 缺失该 slot 时，
 *   会按 probability 从高到低依次降级到下一个拥有该 slot 的 partner
 *
 * 返回的广告对象会附带 _partnerKey / _partnerName，便于埋点上报
 */
export function createAdSession(group) {
  const primary = pickPartner(group)

  function hasSlot(p, slotName) {
    const slot = p && p.slots && p.slots[slotName]
    return !!(slot && slot.ads && Object.keys(slot.ads).length)
  }

  // 兜底顺序：按 probability 从高到低排序的 partner 列表（排除主 partner）
  const fallbackChain = group && group.partners
    ? Object.entries(group.partners)
        .map(([key, p]) => ({ ...p, _key: key }))
        .filter((p) => !primary || p._key !== primary._key)
        .sort((a, b) => (b.probability || 0) - (a.probability || 0))
    : []

  return {
    primaryPartner: primary,
    pickAd(slotName) {
      // 1) 优先主 partner
      let partner = hasSlot(primary, slotName) ? primary : null
      // 2) 兜底：按 probability 从高到低依次尝试，命中第一个含该 slot 的 （注释部分代码是这样的）
      // 3) 从其他拥有该 slot 的 partner 中按权重随机
      if (!partner) {
        // partner = fallbackChain.find((p) => hasSlot(p, slotName)) || null
        partner = pickPartner(
          group,
          (p) => p._key !== (primary && primary._key) && hasSlot(p, slotName)
        )
      }
      if (!partner) return null
      const ad = weightedPick(Object.values(partner.slots[slotName].ads))
      if (!ad) return null
      return { ...ad, _partnerKey: partner._key, _partnerName: partner.name }
    },
  }
}
